<template>
  <div
    class="navigator"
    :class="{
      service: $route.path == '/service',
      about: $route.path == '/about',
    }"
  >
    <div class="wrapper pc">
      <img
        src="../assets/logo.png"
        alt=""
        @click="$router.push({ path: '/' })"
      />
      <div class="routers">
        <router-link
          :to="{ path: item.path }"
          :class="{ active: $route.path == item.path }"
          v-for="item in route"
		  :key="item.name"
          >{{ item.name }}</router-link
        >
      </div>
    </div>
    <div class="mobile mobile-naviagtor">
      <img src="" class="logo" />
      <img
        src="../assets/menu.png"
        @click="drawer = true"
        class="menu mobile"
      />
    </div>
    <el-drawer :size="'50%'" :visible.sync="drawer">
      <div class="nav-drawer">
        <img
          src="../assets/logo.png"
          class="logo"
          @click="$router.push({ path: '/' })"
        />
        <p class="name">兴致力</p>
        <ul>
          <router-link
            :to="{ path: item.path }"
            :class="{ active: $route.path == item.path }"
            tag="li"
			 :key="item.name"
            v-for="item in route"
          >
            <span></span> {{ item.name }}</router-link
          >
        </ul>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
    }
  },
  watch: {
    '$route.path': {
      handler() {
        this.drawer = false
      },
      deep: true,
    },
  },
  computed: {
    route() {
      return this.$router.options.routes.slice(
        1,
        this.$router.options.routes.length - 2
      )
    },
  },
}
</script>

<style lang="less" scoped>
.navigator.service {
  background: transparent;
  position: fixed;
  left: 0;
  width: 100%;
  .wrapper {
    .routers {
      a {
        color: white;
      }
    }
  }
}
.navigator.about {
  position: relative;
}
.navigator {
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(4, 19, 26, 0.1);
  position: sticky;
  top: 0;
  z-index: 10;

  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      height: 70px;
      object-fit: cover;
      cursor: pointer;
    }

    .routers {
      a {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 100px;
        color: #1a1a1a;
        text-decoration: none;
        transition: all 0.15 linear;
        height: 100px;
        margin-right: 60px;
        position: relative;
        display: inline-block;
      }

      a::after {
        position: absolute;
        content: '';
        width: 0;
        height: 2px;
        background: #006c8f;
        bottom: 0;
        left: 0;
        transition: all 0.15s linear;
      }

      a:last-child {
        margin-right: 0;
      }

      a.active {
        color: #006c8f;
      }

      a:not(.active):hover::after {
        width: 100%;
      }
    }
  }
}
@media (max-width: 767px) {
  .navigator {
    height: 0.88rem;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 20007;
    .mobile-naviagtor {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.34rem;
      box-sizing: border-box;
      .logo {
        height: 0.54rem;
      }
      .menu {
        height: 0.36rem;
      }
      .menu:hover {
        opacity: 0.78;
      }
    }
  }
  .nav-drawer {
    padding-top: 0.96rem;
    .logo {
      object-fit: cover;
      display: block;
      margin: 0 auto;
      height: .67rem;
    }
    .name {
      text-align: center;
      font-size: 0.28rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 24px;
      color: #1a1a1a;
      margin-top: 0.24rem;
      margin-bottom: 0.96rem;
    }
    ul {
      li {
        padding-left: 1.16rem;
        box-sizing: border-box;
        line-height: 0.8rem;
        position: relative;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #091905;
        span {
          display: inline-block;
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          background: white;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0.48rem;
        }
      }
      li.active {
        background: #006c8f;
        color: white;
      }
    }
  }
}
</style>
